export default "__VITE_ASSET__32a71a8b__"